<template>
  <main>
    <div class="jumbotron">
      <div class="tint">
        <div class="jumbo-content">
          <!-- Decoration, not the page's heading: the one h1 is "Lägenhetsbyte som det borde vara"
               below (SEO 2026-09-22; the first-pass HTML in public/seo/home.html has no jumbotron). -->
          <span class="jumbo-title">Vill du bo {{ currentword }}</span>
          <h2>På BytBostad hittar du bytet!</h2>
          <!-- <button class="button-submit secondary">Börja byta idag</button> -->
          
          
          <router-link
            v-if="myAds.length"
            
            :to="{ name: 'adlist' }"
            class="button-submit secondary"
            style="width:auto;text-decoration: none; font-weight:600;"
            >
            Hitta byten
          </router-link>

          <router-link
            v-else
            :to="{ name: 'create-ad' }"
            class="button-submit secondary"
            style="width:auto;text-decoration: none; font-weight:600;"

            >
            Börja byta idag
          </router-link>
        </div>
      </div>
    </div>




    
    <div class="grid-container">
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 " style="background-color: white;margin-top:24px;margin-bottom:24px;border-radius: 16px;">

          <!-- THE h1. The text of this page is copied in public/seo/home.html (first-pass HTML for
               crawlers): change the wording in both files. -->
          <h1 style="text-align: center; font-size:36px;padding:24px;">Lägenhetsbyte som det borde vara</h1>
          <p class="ingress">
            Du har rätt att byta din bostad om du har beaktansvärda skäl. Kanske
            behöver du bo närmare jobbet eller barnen? Har barnen flyttat ut och du
            bor för stort och dyrt, eller skall du flytta ihop med någon och behöver bo
            större?
          </p>

          <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-7">
              <p>
                Oavsett vilken anledning du har för att vilja göra ett
                <strong>lägenhetsbyte</strong> så är det en tidsödande process
                att hitta ett byte som matchar just det som passar dig.
              </p>
              <p>
                Därför har vi utvecklat <strong>BytBostad</strong>, för dig som
                har förstahandskontrakt på en hyresrätt. Vi matchar
                dig med tusentals andra bostadsinnehavare och ser till att hitta
                ett direktbyte eller triangelbyte.
              </p>
              <p>
                Du behöver bara berätta vad du har för bostad idag samt vad du
                söker, sedan säger du <span class="primary">ja</span> eller
                <span class="secondary">nej</span> till de bostäder som
                presenteras.
              </p>
              <p>
                Våra robotar kopplar ihop dig med andra bostadsinnehavare helt
                automatiskt!
              </p>
            </div>
            <div class="cell small-12 medium-5" style="display:grid;place-content: center;">
              <img src="/img/bb-demo.gif" alt="BytBostad" style=""/>
            </div>
          </div>
          <div class="grid-x grid-padding-x usp">
            <div class="cell small-12 medium-4">
              <h2>Enkelt</h2>
              <p>
                Det enda du behöver göra är att berätta vilka bostäder du
                gillar, vi matchar sedan ihop både <strong>direktbyten</strong> och
                <strong>triangelbyten</strong>.
              </p>
            </div>
            <div class="cell small-12 medium-4">
              <h2>Tryggt</h2>
              <p>
                När du har en komplett byteskedja där alla sagt ja till varandra, så får ni möjlighet att kontakta varandra, men inte innan dess.
              </p>
            </div>

            <div class="cell small-12 medium-4">
              <h2>Roligt</h2>
              <p>
                Att svajpa igenom listan med förslag är kul. Gör det till en vana att kika in på BytBostad och se om det finns något nytt.
              </p>
            </div>
          </div>

          <div class="grid-x grid-padding-x " style="padding-top:24px; padding-bottom: 24px;">
            <div class="cell small-12 medium-5" style="place-content: center;display:grid;">
              <img src="/img/smile.jpg" style="border-radius:8px;rotate:-3deg;max-width: 200px;" />
            </div>
            <div class="cell small-12 medium-7" style="place-content: center;">
              <h2>Man kan alltid bo bättre</h2>
              <p>
                <em>
              "Även om man tror sig ha hittat sin drömbostad så finns det
                  
                  alltid en möjlighet att byta upp sig. Det kan handla om en
                  bostad i samma trappuppgång men med lägre hyra, bättre utsikt
                  eller en Terrass."
                </em>
              </p>
              <p>
                Med hjälp av triangelbyten kan vi hitta byten du inte trodde var
                möjliga.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-x grid-padding-x ">
      <div class="cell small-12 spacer"></div>
    </div>

    <div class="grid-x grid-padding-x " >
      <div class="cell small-12 medium-6  box1" style="padding-top:24px;padding-bottom:24px;">
        <div class="grid-x ">
          <div class="cell small-12 large-7 large-offset-4">
            <h2>Fokus på aktivitet</h2>
            <p>
              Vi jobbar kontinuerligt med att hålla våra medlemmar uppdaterade
              och aktiva. Ingen vill sitta och vänta på ett byte.
            </p>
          </div>
        </div>
      </div>
      <div class="cell small-12 medium-6  box2" style="padding-top:24px;padding-bottom:24px;">
        <div class="grid-x ">
          <div class="cell large-1"></div>
          <div class="cell small-12 large-7">
            <h2>Störst i storstäderna</h2>
            <p>
              De flesta av våra medlemmar söker bostad i Stockholm eller
              Göteborg, men det finns önskemål om bostäder i nästan hela
              Sverige.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="grid-x grid-padding-x ">
      <div class="cell small-12 "><h1>&nbsp;</h1></div>
    </div> -->

    <div class="grid-container" style="margin-top:24px;">

    <div class="grid-x grid-padding-x" style="padding-top:24px; padding-bottom: 24px;background-color: white;margin:auto;border-radius:16px"
    
    >
      <div class="cell small-12 medium-12 ">
        <h2 style="padding:24px;text-align: center;font-size:36px;">De flesta vill bo större</h2>
        <p class="ingress">
          Den vanligaste anledningen att byta bostad är att man vill bo lite
          större än man gör idag, hela 44% av våra medlemmar har angett att dom
          vill göra ett <strong>lägenhetsbyte</strong> på grund av att dom bor
          för litet. 15% av våra medlemmar har däremot uppgett att dom bor för
          stort.
        </p>
      </div>
    <!-- </div>
    <div class="grid-x grid-padding-x"> -->
      <div class="cell small-12 medium-6">
        <h3>Göteborg ligger tvåa på önskelistan</h3>
        <p>
          Göteborg är Sveriges andra största stad. Det är också den näst
          populäraste staden att flytta till. 20% av våra medlemmar vill flytta
          till Göteborg medan hela 63% vill flytta till
          eller inom Stockholm.
        </p>
        <h3>Stockholm är populärast</h3>
        <p>
          Stockholm är vår huvudstad och också den stad dit flest vill flytta.
          Dom populäraste områdena är Kungsholmen, Vasastaden, Östermalm och
          Södermalm.
        </p>

        <h3>Vissa söker lugnet</h3>
        <p>
          En del är trötta på storstäderna och vill ha något lugnare. Det är inte helt ovanligt att man söker sig till landet när man blivit äldre och tröttnat på stöket i stan.
        </p>
      </div>
      <div
        class="cell small-12 medium-6"
        style="background:url('/cdn-cgi/image/width=1600,quality=80,format=auto/img/goteborg/edvin-johansson-1272415-unsplash.jpg');background-size:cover;  background-position: center center;"
      >
      </div>
    </div>

   
  </div>

  <!-- Same heading and alt texts as public/seo/home.html (the first-pass HTML). -->
  <h2 style="text-align:center;padding:24px 8px 0;">Bostäder för lägenhetsbyte just nu</h2>
  <div class="selected-listings-grid">
      <router-link v-for="bostad in frontPage" :key="bostad.id"  :to="{ name: 'ad', params: { id: bostad.id } }" class="bostad-item">
<div style="position:relative;background-color: blue;border-radius:8px;aspect-ratio: 1/1; position:relative;cursor:pointer;overflow:hidden;">

  <img :src="'https://bytbostad.se/bilder/square/' + bostad.photo + '.jpg'" :alt="bostad.address + ', ' + bostad.city + ' - bostad för lägenhetsbyte'" @error="errorImage" style="  object-fit: cover;width:100%;height:100%;">
  
  <div style="color:white;background-color:rgba(0, 0, 0, 0.32); font-size:12px;position: absolute; top:0; bottom:0;right:0;left:0;display:grid;place-content: center;text-align: center;">
    <span>{{ bostad.rooms }}:a {{ bostad.size}} m<sup>2</sup></span>
    {{ bostad.address }}<br />
    <span style="font-size:14px;">{{  bostad.city }}</span></div>
</div>

        <!-- {{  bostad.id }} -->

                <!-- <td class="bostad-photo">
                  <img :src="'https://bytbostad.se/bilder/square/' + bostad.photo" :alt="bostad.address" @error="errorImage">
                </td>
                <td>
                  <p class="address">
                    {{ bostad.address }}
                  </p><span class="city address">{{ bostad.city }}</span>
                </td>
                <td class="show-for-medium rooms">
                  {{ bostad.rooms }}
                </td>
                <td class="show-for-medium size">
                  {{ bostad.size }} m<sup>2</sup>
                </td>
                <td class="show-for-medium rent">
                  {{ bostad.rent | currency }}
                </td> -->
               
              </router-link>

            </div>

            
    <!-- <div class="grid-x grid-padding-x footerinfo">
      <div class="cell small-12 ">
        <center>
          <p>
            <strong>BytBostad</strong> drivs av Svenska Bostadssajterna AB
            (559160-8657) Telefon: 08-121314 Epost: hej@bytbostad.se Följs oss
            på <a>Facebook</a>, <a>Instagram</a> eller <a>Twitter</a>
          </p>
        </center>
      </div>
    </div> -->
   
  </main>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      words: [
        'billigare',
        'större',
        'centralare',
        'mindre',
        'närmare jobbet',
        'ensam',
        'bättre'
      ],
      currentnumber: 0
    }
  },
  computed: {
    ...mapGetters(['myAds', 'frontPage']),
    currentword () {
      return this.words[this.currentnumber]
    }
  },
  mounted () {
    this.intervalid1 = setInterval(() => {
      // this.changes = (Math.random() * 100).toFixed(2) + '%'
      // console.log(this.changes)
      this.changeWord()
    }, 1500)
  },
  methods: {
    errorImage(event) {
      event.target.src = '/img/nophoto.svg'
    },
    changeWord () {
      if (this.currentnumber + 1 == this.words.length) {
        this.currentnumber = 0
      } else {
        this.currentnumber++
      }
    }
  }
}
</script>

<style lang="scss" scoped>


@import '@/scss/abstracts/_variables.scss';

.box1 {
  background-color: $color-primary;
}

.box2 {
  background-color: $color-secondary;
}

.box3 {
  background-color: #ffba52;
}

.box1 h2,
.box2 h2,
.box1 p,
.box2 p {
  color: white;
}
// Was an empty <h1>&nbsp;</h1> used as a spacer.
.spacer {
  height: 3rem;
}
// The section headings were h1 until 2026-09-22 (ten h1 on one page); same size as before.
.usp h2,
.box1 h2,
.box2 h2 {
  font-size: 2rem;
}
h3 {
  font-size: 1.5rem;
}
// .primary,
// .secondary {
//   font-weight: bold;
//   text-decoration: underline;
// }
// .primary {
//   color: $color-primary;
// }

// .secondary {
//   color: $color-secondary;
// }
.grid-container {
  max-width: 800px;
  // margin-top: 74px;
}

.usp h2 {
  // text-align: center;
  color: $color-primary;
}

.usp h2:before {
  content: '✔';
  color: $color-secondary;
  margin-right: 6px;
}

.footerimage {
  // margin-top: 74px;
  height: 500px;
  width: 100%;
  // background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
  //   url('/img/familj.jpeg');

  // Through Cloudflare's resizer, as page_server.php does for the map images: the original is an
  // 831 kB full-resolution Unsplash file and this is a full-width fixed background. format=auto
  // serves AVIF/WebP where supported and falls back to JPEG everywhere else.
  background-image: linear-gradient(
      rgba($color-secondary, 0.5),
      rgba($color-primary, 0.5)
    ),
    // url('/img/stockholm.jpg');
      url('/cdn-cgi/image/width=1920,quality=80,format=auto/img/goteborg/jonas-jacobsson-1316804-unsplash.jpg');

  background-size: cover;
  background-position: center center;
  background-attachment: fixed;

  display: table-cell;
  // width: 500px;
  // height: 500px;
  vertical-align: middle;
  text-align: center;
}

.jumboimage {
  margin-top: 74px;
  height: 60vh;
  width: 100%;
  // background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
  //   url('/img/familj.jpeg');

  background-image: linear-gradient(
      rgba($color-secondary, 0.5),
      rgba($color-primary, 0.5)
    ),
    url('/img/familj.jpeg');

  background-size: cover;
  background-position: center center;

  display: table-cell;
  // width: 500px;
  // height: 500px;
  vertical-align: middle;
  text-align: center;
}

.jumboimage h1,
.footerimage h1 {
  // display: table;
  // margin: 0 auto;
  display: inline-block;
  width: 100vw;
  // height: 200px;
  color: $color-primary;
  color: white;
  font-size: 70px;
  line-height: 64px;
  margin-bottom: 20px;
}
.footerimage h2 {
  color: white;
}
.jumboimage h2 {
  display: inline-block;
  width: 100vw;
  // height: 200px;
  color: $color-primary;
  color: white;
  font-size: 30px;
  // line-height: 64px;
  margin-top: -15px;
}
.ingress {
  font-size: 24px;
  line-height: 30px;
}

.footerinfo {
  background-color: white;
}
.footerinfo p {
  color: #979797;
  font-size: 12px;
}


.grid-container p{
  margin-bottom:15px;
}


.selected-listings-grid{
  display:grid;grid-template-columns: repeat( auto-fit, minmax(250px, 1fr) );
  @media screen and (max-width: 650px) {
    grid-template-columns: repeat( auto-fit, minmax(150px, 1fr) );
  }
;max-width:1920px; grid-gap:8px; margin:auto;padding:8px;
}

</style>
